export function flexText2 () {
    function bty_flexText() {
        let selector = document.body.querySelector('#marketing-ofthe-future');
        let width = selector.offsetWidth;
    }

    // window.onload = bty_rotateAdjuster;
    document.addEventListener('DOMContentLoaded', function () {
        bty_flexText();
    });
};
